import React from "react";
import { Table, Form, InputGroup, Button } from "react-bootstrap";
import { Eye } from "react-bootstrap-icons";

const SuppliersAdmin = () => {
  const suppliers = [
    { id: "SUP-101", name: "Acme Manufacturing", category: "Electronics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Raw Materials", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
    { id: "SUP-101", name: "Acme Manufacturing", category: "Plastics", rating: 4.2 },
  ];

  return (
    <div className="container my-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Suppliers</h4>
      </div>

      {/* Search + Filter */}
      <div className="d-flex align-items-center gap-3 mb-3">
        <InputGroup style={{ maxWidth: "300px" }}>
          <Form.Control type="search" placeholder="Search suppliers..." />
        </InputGroup>

        <Form.Select style={{ maxWidth: "200px" }}>
          <option>All Types</option>
          <option>Electronics</option>
          <option>Raw Materials</option>
          <option>Plastics</option>
        </Form.Select>
      </div>

      {/* Total */}
      <p>Total: {suppliers.length}</p>

      {/* Table */}
      <div className="table-responsive">
        <Table bordered hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Category</th>
              <th>Rating</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {suppliers.map((s, i) => (
              <tr key={i}>
                <td>
                  <a href="/" className="text-primary fw-bold text-decoration-none">
                    {s.id}
                  </a>
                </td>
                <td>{s.name}</td>
                <td>{s.category}</td>
                <td>{s.rating}</td>
                <td>
                  <Button variant="light" size="sm">
                    <Eye color="red" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-end align-items-center gap-2">
        <Button variant="light">&larr;</Button>
        <span>1</span>
        <span>2</span>
        <Button variant="light">&rarr;</Button>
      </div>
    </div>
  );
};

export default SuppliersAdmin;
